<div class="grid-flex-select-container region-grid-select-filter"></div>
<div class="dynamic-search-control" data-control="searchContainer"></div>
<div class="dynamic-search-footer" data-control="footer"></div>